export const openUrl = async (url: string, target: '_blank' | '_self' = '_blank'): Promise<void> => {
  const { Capacitor } = await import('@capacitor/core');
  if (Capacitor.isNativePlatform()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url });
  } else {
    window.open(url, target, 'noopener,noreferrer');
  }
};

export const openInMaps = async (latitude: number, longitude: number): Promise<void> => {
  const url = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
  await openUrl(url);
};
